import Layout from "../components/Layout";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../utils/commonUrl";
import { DataTable } from "primereact/datatable";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column } from "primereact/column";
import { get } from "react-hook-form";
import { ProgressSpinner } from "primereact/progressspinner";
import QuarterNames from "../components/QuarterNames";
import { useSelector } from "react-redux";
// import {MultiSelect} from 'primereact/multiselect';

import { MultiSelect } from "react-multi-select-component";

import "primereact/resources/primereact.min.css";

const options = [
    { label: "Grapes 🍇", value: "grapes" },
    { label: "Mango 🥭", value: "mango" },
    { label: "Strawberry 🍓", value: "strawberry", disabled: true },
];

const cssVars={
    '--rmsc-h': 15
}

const EmployeeStatus = () => {
    const [selected, setSelected] = useState([]);
    const { user } = useSelector((state) => state["auth"]);
    const [factoryData, setFactoryData] = useState([])
    const [departmentData, setDepartmentData] = useState([])
    const [designationData, setDesignationData] = useState([])
    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');
    const [start, setFirst] = useState(0);
    const [getFilterData, setGetFilterData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [employeeList, setEmployeeList] = useState([]);
    const [citiesList, setCities] = useState('');

    const [quarterNames, setQuarterNames] = useState([]);
    const [monthNames,setMonthNames]=useState([]);



    useEffect(() => {
        initFilters1()
        GetEmployeeFilterData()
        GetEmployeeList();
        GetSubmittedQuarterNames(user.registerID);
        GetAllMonthList();
    }, [])

    const GetSubmittedQuarterNames = (id) => {
        axios
            .post(BASE_URL + `/api/dashboard/GetSubmittedQuarterNames/${id}`)
            .then((response) => {
                setQuarterNames(
                    response.data.map((record) => {
                        return {
                            value: record.quarterID,
                            label: record.quarterName,
                        }
                    }),
                )
                //console.log(quarterNames);
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    const GetAllMonthList = () => {
        axios.post(BASE_URL + `/api/utility/GetAllMonth`)
            .then((response) => {
                console.log(response);
                setMonthNames(
                    response.data.map((record) => {
                        return {
                            value: record.monthID,
                            label: record.monthName,
                        }
                    }),
                )
                //console.log(quarterNames);
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    const GetEmployeeFilterData = () => {
        axios.get(BASE_URL + "/api/report/GetFilterFactoryData")
            .then(response => {
                setFactoryData(response.data)
            })
            .catch(console.error)

        axios.get(BASE_URL + "/api/report/GetFilterDepartmentData")
            .then(response => {
                setDepartmentData(response.data)
            })
            .catch(console.error)

        axios.get(BASE_URL + "/api/report/GetFilterDesignationData")
            .then(response => {
                //console.log(response.data);
                setDesignationData(response.data)
            })
            .catch(console.error)
    }


    const onGlobalFilterChange1 = (e) => {
        const value = e.target.value;
        let _filters1 = { ...filters1 };
        _filters1['global'].value = value;
        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }

    const GetEmployeeList = () => {
        var e = document.getElementById("emp_factory");
        var _selectedValue = e.value === "-1" ? user.quarterID : e.value;
        //console.log(_selectedValue);
    }

    const initFilters1 = () => {
        setFilters1({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'employeeName': {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
            },
            'department': {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
            },
            'designation': {
                operator: FilterOperator.AND,
                constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }]
            },
        });
        setGlobalFilterValue1('');
    }

    const clearFilter1 = () => {
        initFilters1();
    }

    const exportExcel = () => {
        import('xlsx').then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(getFilterData);
            const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
            saveAsExcelFile(excelBuffer, 'Employee Information');
        });
    }

    const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then(module => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE
                });

                module.default.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
            }
        });
    }

    const PMSStatusExportExcel = () => {
        //var e = document.getElementById("ddlQuarter");
        //var _QuarterIDValue = e.value === "-1" ? user.quarterID : e.value;//SearchStr="+btoa("QuarterID="+ _QuarterIDValue));
        //console.log(btoa("QuarterID=" + _QuarterIDValue));
        //console.log(atob(btoa("QuarterID=" + _QuarterIDValue)));

        const factory = document.getElementById("emp_factory").value
        const emp_dept = document.getElementById("emp_dept").value
        const emp_designation = document.getElementById("emp_designation").value
        const joiningMonth=document.getElementById("emp_Month").value;
        var selectedQuarters=selected.map(o=>o.value)
        const quarterIDList= selectedQuarters.toString();

        //window.open("https://apps.bitopibd.com/BIMOBApps/PMSReport/PMSStatusReport?SearchStr=" + btoa("QuarterID=" + _QuarterIDValue));
        //window.open("https://apps.bitopibd.com/BIMOBApps/PMSReport/PMSStatusReport?SearchStr=" + btoa("Factory=" + factory+"&Department="+emp_dept+"&Designation="+emp_designation+"&JoiningMonthID="+joiningMonth+"&QuarterIDList="+quarterIDList));
        //window.open("http://localhost:13805/PMSReport/PMSStatusReport?SearchStr=" + btoa("Factory=" + factory+":Department="+emp_dept+":Designation="+emp_designation+":JoiningMonthID="+joiningMonth+":QuarterIDList="+quarterIDList));
        window.open("https://apps.bitopibd.com/BIMOBApps/PMSReport/PMSStatusReport?SearchStr=" + btoa("Factory=" + factory+":Department="+emp_dept+":Designation="+emp_designation+":JoiningMonthID="+joiningMonth+":QuarterIDList="+quarterIDList));
    };

    const header = (
        <div className="table-header">
            <div className='d-flex justify-content-between'>
                <div>
                    <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined"
                        onClick={clearFilter1} />
                    <span className="p-input-icon-left"> <i className="pi pi-search" />
                        <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1}
                            placeholder="Keyword Search" />
                    </span>
                </div>
                {isLoading ? <ProgressSpinner style={{ height: 50, width: 50 }} /> : ""}
                <Button type="button" icon="pi pi-file-excel" onClick={PMSStatusExportExcel} className="p-button-success mr-2" data-pr-tooltip="XLS" />

            </div>
        </div>
    );

    const assessmetbody = ({ totalAssesmentSubmission, totalAssesmentForSubmit }) => (<>
        <span>{Number(totalAssesmentSubmission) === Number(totalAssesmentForSubmit) ?
            <span class="product-badge status-complete">Completed</span> :
            <span class="product-badge status-incomplete">Not Completed</span>
        }
        </span>
    </>
    )
    const competencyBody = ({ totalCompetencySubmission, totalCompetencyForSubmit }) => (<>
        <span>{Number(totalCompetencySubmission) === Number(totalCompetencyForSubmit) ?
            <span class="product-badge status-complete">Completed</span> :
            <span class="product-badge status-incomplete">Not Completed</span>
        }</span>
    </>
    )
    const skillMatrixBody = ({ totalUserSkillMatrix, skillMatrixCompleted }) => (<>

        <span>{Number(skillMatrixCompleted) > 0 && Number(totalUserSkillMatrix) === Number(skillMatrixCompleted) ?
            <span class="product-badge status-complete">Completed</span> :
            <span class="product-badge status-incomplete">Not Completed</span>
        }</span>
    </>
    )

    return (<Layout>

        <div className="card">

            <div className="card-header">
                <div className="row">
                    <div className="col-md-2">
                        <select className="form-select form-select-sm" aria-label=".form-select-sm example"
                            id="emp_factory">
                            <option value="">Factory</option>
                            {factoryData.map((value, index) => {
                                return <option key={index} value={value.factoryName}>{value.factoryName}</option>
                            })}

                        </select>
                    </div>
                    <div className="col-md-3">
                        <select className="form-select form-select-sm" aria-label=".form-select-sm example"
                            id="emp_dept">
                            <option value="">Department</option>
                            {departmentData.map((value, index) => {
                                return <option key={index} value={value.department}>{value.department}</option>
                            })}
                        </select>
                    </div>
                    <div className="col-md-2">
                        <select className="form-select form-select-sm" aria-label=".form-select-sm example"
                            id="emp_designation">
                            <option value="">Designation</option>
                            {designationData.map((value, index) => {
                                return <option key={index} value={value.designation}>{value.designation}</option>
                            })}
                        </select>
                    </div>

                    <div className="col-md-2">
                        <select className="form-select form-select-sm" aria-label=".form-select-sm example"
                            id="emp_Month">
                            <option value="">Month</option>
                            {monthNames.map((value, index) => {
                                return <option key={index} value={value.value}>{value.label}</option>
                            })}

                        </select>
                    </div>

                    {/* <div className="col-md-2">
                        <MultiSelect
                            options={options}
                            value={selected}
                            onChange={setSelected}
                            labelledBy="Select"
                        />
                    </div> */}


                    <div className="col-md-3">
                        <MultiSelect style={cssVars}
                            options={quarterNames}
                            value={selected}
                            onChange={setSelected}
                            labelledBy="Quarter"
                            id="ddlMultiQuarter"  
                            size="lg"                          
                        />
                    </div>

                   

                    {/* <div className="col-md-3">
                        <QuarterNames />
                    </div> */}
                    <div className="col-md-2">
                        <button className="btn btn-primary btn-sm" onClick={() => {
                            setIsLoading(true);
                            
                            //var e = document.getElementById("ddlMultiQuarter");
                            //var _selectedValue =e.value === "-1" ? user.quarterID : e.value;
                            

var selectedQuarters=selected.map(o=>o.value)
//console.log(selectedQuarters);



                            const factory = document.getElementById("emp_factory").value
                            const emp_dept = document.getElementById("emp_dept").value
                            const emp_designation = document.getElementById("emp_designation").value
                            const joiningMonth=document.getElementById("emp_Month").value===""?"-1":document.getElementById("emp_Month").value;
                            const _QuarterID = selectedQuarters;

                           

                            const data = {
                                FactoryName: factory,
                                Department: emp_dept,
                                Designation: emp_designation,
                                JoiningMonthID:joiningMonth,
                                QuarterIDList: selectedQuarters.toString()
                            }
                            console.log(data)
                            axios.post(BASE_URL + "/api/report/GetFilterData", JSON.stringify(data))
                                .then(response => {
                                    setGetFilterData(response.data)
                                    setIsLoading(false);
                                })
                                .catch(function (error) {
                                    setIsLoading(false);
                                    console.log(error);
                                });
                        }}><i class="bi bi-funnel"></i> Filter
                        </button>
                        <button className="btn ms-2 text-white btn-info btn-sm"><i class="bi bi-eraser"></i> Clear</button>
                    </div>
                </div>
            </div>
            <div className="card-body" style={{overflow:'scroll'}}>
                {/* {isLoading ? <ProgressSpinner style={ {height:50,width:50} }/> : ""} */}
                <DataTable value={getFilterData}
                    header={header}
                    resizableColumns
                    showGridlines
                    dataKey="registerID"
                    filters={filters1}
                    filterDisplay="menu"
                    globalFilterFields={['employeeName', 'department', 'designation']}
                    paginator rows={10} first={start}
                    paginatorTemplate="RowsPerPageDropdown PageLinks FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink">
                    <Column field='registerID' header="RegisterID" hidden={true} />
                    <Column field="factoryName" header="Factory" sortable className="text-center"></Column>
                    <Column field='employeeCode' sortable header="Employee Code" />
                    <Column field='employeeName' sortable header="Employee Name" />
                    <Column field='quarterName' sortable header="Quarter Name" />
                    <Column field='totalAssesmentSubmission' sortable className="text-center" header={"Core Values"} body={assessmetbody} />
                    <Column field='totalCompetencySubmission' sortable className="text-center" header={"Core Competency"} body={competencyBody} />
                    <Column field='totalCompetencySubmission' sortable className="text-center" header={"Skill Will Matrix"} body={skillMatrixBody} />
                    <Column field='department' sortable header="Department" />
                    <Column field='designation' sortable header="Designation" />
                    <Column field='supervisorName' sortable header="Supervisor Name" className="text-center" />
                    <Column field='assestmentMark' sortable header="Core Values" className="text-center" />
                    <Column field='competencyMark' sortable header="Core Competency" className="text-center" />
                    <Column field='matrixMark' sortable header="Skill Will Matrix" className="text-center" />
                    <Column field='grandTotalMark' sortable header="Full Score" className="text-center" />
                    <Column field='totalMark' sortable header="Obtained Score" className="text-center" />
                    <Column field='totalPercentage' sortable header="Obtained Score (%)" className="text-center" />
                </DataTable>
            </div>
        </div>

    </Layout>)
}

export default EmployeeStatus